import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//FONT 
// import './asset/font/Sparkasse_web_V2.04/Sparkasse_Rg.ttf'; FONT TEST
import './asset/font/creditCard/OCRAStd.otf'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
